module.exports = __webpack_public_path__ + "static/media/rolling.a874e692.svg";